import { useTranslation } from 'react-i18next';

import { i18nNS } from '../../../../../i18n';
import BarGraphIcon from '../../../../../icons/BarGraphIcon';
import BarGraphWhiteIcon from '../../../../../icons/BarGraphWhiteIcon';
import Tile from '../../../../shared/Tile';
import BarGraphDrawer from '../BarGraphDrawer';
import useBarGraphTile from './vm';

const BarGraphTile = () => {
  const { t } = useTranslation([i18nNS.POLL]);

  const { isBarGraphDrawerOpen, handleCloseBarGraphDrawer, handleClick } = useBarGraphTile();

  return (
    <>
      <Tile
        icon={BarGraphWhiteIcon}
        hoverIcon={BarGraphIcon}
        title={t('bar_graph', { ns: i18nNS.POLL })}
        onClick={handleClick}
        isActive={isBarGraphDrawerOpen}
      />
      <BarGraphDrawer open={isBarGraphDrawerOpen} onClose={handleCloseBarGraphDrawer} />
    </>
  );
};

export default BarGraphTile;
